import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import './InfoCard.scss';
import _data from '../../locales/en.json';
import PropTypes from 'prop-types';
import { ArrowRight16 } from '@carbon/icons-react';
import { CSSTransition } from 'react-transition-group';
import { useSelector } from 'react-redux';
import { ScaleText } from '../../utils';

const InfoCard = ({ cmsLocale }) => {
  const [data, setData] = useState(_data.Content.home);
  const [rootID, setRootID] = useState('Content.home');
  const [isScene, setIsScene] = useState(false);

  const home = useSelector((state) => state.home);
  const currentScene = useSelector((state) => state.currentScene);
  const infocardIn = useSelector((state) => state.infocardIn);

  const scaledText = ScaleText(
    `${rootID}.title`,
    { xlg: 10, lg: 10, tablet: 24, mobile: 18 },
    '1.19em',
  );

  let localeCode = cmsLocale || '';

  if (localeCode.indexOf('-') > -1) {
    // IBM's Drupal changes the url prefix to be `country-language`,
    // so we need to adapt the provided langcode.
    localeCode = `${localeCode.split('-')[1]}-${localeCode.split('-')[0]}`;
  }

  function buildUrl(incomingurl) {
    const url = incomingurl;
    if (url === null) {
      return null;
    }
    return url.toString().charAt(0) === '/'
      ? `${localeCode === 'us-en' ? '' : '/' + localeCode}${url}`
      : url;
  }

  useEffect(() => {
    if (infocardIn) {
      if (home) {
        setData(_data.Content.home);
        setRootID('Content.home');
        setIsScene(false);
      } else {
        setData(_data.Content.scene[currentScene]);
        setRootID(`Content.scene.${currentScene}`);
        setIsScene(true);
      }
    }
    // eslint-disable-next-line
  }, [infocardIn]);

  return (
    <div className="infocard-container">
      <div className="bx--grid">
        <div className="bx--row">
          {isScene && (
            <div className="bx--col-sm-0 bx--col-md-0 bx--col-lg-12"></div>
          )}
          <div
            className={`bx--col-sm-4 bx--col-md-5 bx--col-lg-${
              isScene ? 4 : 5
            }`}>
            <div className="infocard" id={isScene ? 'scene' : ''}>
              <CSSTransition
                in={infocardIn}
                timeout={{ enter: 400, exit: 400 + 300 }}
                classNames="infocard-display"
                unmountOnExit>
                <div className="title expressive-heading-06 white slow-01">
                  <FormattedMessage
                    id={`${rootID}.title`}
                    defaultMessage={data.title}>
                    {(txt) => (
                      <div className="title-text" style={scaledText}>
                        {txt}
                      </div>
                    )}
                  </FormattedMessage>
                </div>
              </CSSTransition>

              <CSSTransition
                in={infocardIn}
                timeout={{ enter: 400, exit: 400 + 300 }}
                classNames="infocard-display"
                unmountOnExit>
                <div className="content expressive-heading-03 white slow-01">
                  <FormattedMessage
                    id={`${rootID}.content`}
                    defaultMessage={data.content}
                  />
                </div>
              </CSSTransition>

              <CSSTransition
                in={infocardIn}
                timeout={{ enter: 400, exit: 400 + 300 }}
                classNames="infocard-display"
                unmountOnExit>
                <div className="links body-short-01 slow-01">
                  {data.links.map((link, i) => {
                    return (
                      <div key={i}>
                        <FormattedMessage id={`${rootID}.links.${i}.href`}>
                          {(href) => (
                            <a href={buildUrl(href)}>
                              <FormattedMessage
                                id={`${rootID}.links.${i}.text`}
                                defaultMessage={link.text}>
                                {(txt) => (
                                  <span className="body-short-01 link-text blue-50">
                                    {txt}
                                    <svg
                                      style={{
                                        width: '10px',
                                        height: '10px',
                                      }}></svg>
                                    <ArrowRight16 />
                                  </span>
                                )}
                              </FormattedMessage>
                            </a>
                          )}
                        </FormattedMessage>
                      </div>
                    );
                  })}
                </div>
              </CSSTransition>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

InfoCard.propTypes = {
  cmsLocale: PropTypes.string,
};

export default InfoCard;
